import React, { Component } from "react";
import PropTypes from "prop-types";

import NavigationView from "features/application/navigation/view";

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.navigationReference = React.createRef();

    this.toggleNavigationVisibility = this.toggleNavigationVisibility.bind(
      this
    );
    this.disableLink = this.disableLink.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentStep } = this.props;

    if (
      nextProps.currentStep &&
      nextProps.currentStep !== currentStep &&
      this.navigationReference.current
    ) {
      let navigation = this.navigationReference.current;

      if (navigation.style.display === "flex") {
        document.querySelector("html").style.overflowY = "visible";
        navigation.style.display = "none";
      }
    }
  }

  toggleNavigationVisibility() {
    if (this.navigationReference.current) {
      let navigation = this.navigationReference.current;

      if (navigation.style.display === "none") {
        document.querySelector("html").style.overflowY = "hidden";
        navigation.style.display = "flex";
      } else {
        document.querySelector("html").style.overflowY = "visible";
        navigation.style.display = "none";
      }
    }
  }

  disableLink(event) {
    const { memberships, userData } = this.props;

    if (
      parseInt(event.target.dataset.step) === 7 &&
      userData &&
      userData.current_step &&
      (userData.is_referred ||
        !userData.use_payment ||
        (memberships.find((membership) => membership.id === userData.plan_id) &&
          memberships.find((membership) => membership.id === userData.plan_id)
            .is_free))
    ) {
      if (userData.use_payment) {
        parseInt(event.target.dataset.step) > userData.current_step + 2 &&
          event.preventDefault();
      } else {
        parseInt(event.target.dataset.step) > userData.current_step + 3 &&
          event.preventDefault();
      }
    } else {
      parseInt(event.target.dataset.step) > userData.current_step + 1 &&
        event.preventDefault();
    }
  }

  render() {
    const { currentStep, userData, memberships } = this.props;

    return (
      <NavigationView
        currentStep={currentStep}
        userData={userData}
        memberships={memberships}
        navigationReference={this.navigationReference}
        toggleNavigationVisibility={this.toggleNavigationVisibility}
        disableLink={this.disableLink}
      />
    );
  }
}

Navigation.propTypes = {
  currentStep: PropTypes.string,
  userData: PropTypes.object,
  memberships: PropTypes.array,
};

export default Navigation;
